<script setup>
import { computed } from "vue";
import { useTranslation } from "i18next-vue";

import { useComponentErrorCapture } from "@/mixins/error";

import VueLoadImage from "vue-load-image";
import ApiConnection from "@/api";

useComponentErrorCapture();

const props = defineProps({
  iconId: {
    type: String,
    default: null,
  },
  fallbackIcon: {
    type: String,
    default: "",
  },
});

const url = computed(() => {
  const patternCtv = /^ctv:/;
  const baseIconId = props.iconId?.replace('custom:', '').replace('ctv:', '');

  if (baseIconId && patternCtv.test(props.iconId)) {
    return ApiConnection.rest().resourceUrl("TvChannelIcon", baseIconId);
  } else if (baseIconId) {
    return ApiConnection.rest().resourceUrl("Icon", baseIconId);
  } else {
    return '';
  }
});

function fallbackIconClasses() {
  return ["icon", props.fallbackIcon];
}

</script>
<template>
  <VueLoadImage v-if="props.iconId">
    <template #image>
      <img :src="url" role="presentation" alt="" />
    </template>
    <template #error>
      <i :class="fallbackIconClasses()" />
    </template>
  </VueLoadImage>
  <div class="vue-load-image" v-else-if="!props.iconId">
    <i :class="fallbackIconClasses()" />
  </div>
</template>
